import React from "react";
import SEO from "./SEO";

const BlogHomeSEO: React.FC = () => {
  const title = "Blog de Evefant | Ideas e inspiración en un solo lugar";
  const description =
    "¿No sabes cómo celebrar tu próximo evento?Ideas, blogs, artículos y más solo en Evefant. Encuentra todo lo que necesitas para tu fiesta y nosotros te lo llevamos. Desde decoración con globos, hasta los bocaditos. Delivery en todo Lima.";
  const image = "https://media.evefant.com/og_Image_62b990aa41.webp"; // Replace with your blog's OG image if available
  const url =
    typeof window !== "undefined" ? `${window.location.origin}/blog` : "/blog";

  const schema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: title,
    description: description,
    url: url,
    publisher: {
      "@type": "Organization",
      name: "Evefant",
      logo: {
        "@type": "ImageObject",
        url:
          typeof window !== "undefined"
            ? `${window.location.origin}/logo192.png`
            : "/logo192.png",
      },
    },
  };

  return (
    <SEO
      title={title}
      description={description}
      image={image}
      type="website"
      schema={schema}
      openGraph={{
        "og:title": title,
        "og:description": description,
        "og:image": { url: image },
        "og:url": url,
        "og:type": "website",
      }}
    />
  );
};

export default BlogHomeSEO;
